<div class="body-content">
  <div class="extrato">
    <div class="demo-tab-content">
      <div class="lista-dados" *ngIf="defaulters.pedidos.length > 0">
        <ul>
          <li>
            <div class="colunas-extrato">
              <h5 style="font-size: 0.85rem;">Valor</h5>
            </div>

            <div class="colunas-extrato">
              <h5 style="font-size: 0.85rem;">Forma de pagamento</h5>
            </div>

          </li>
        </ul>

        <ul *ngFor="let pedido of defaulters.pedidos" class="list-consumo">
          <li>

              <h5 >R$ {{ pedido.Valor.toFixed(2) }}</h5>


              <div class="dado-complementar">{{ pedido.Date | date: 'dd/MM - HH:mm:ss' }}</div>

            <div class="colunas-extrato">
                  
              <h5 class="btn-positive" *ngIf="!pedido.MostraDetalhes" (click)="openChildDetail(pedido.Id)"  style="cursor:pointer; color: #0971B2; font-weight: 600;">
                Detalhes
              </h5>

              <h5 class="btn-positive" *ngIf="pedido.MostraDetalhes" (click)="closeChildDetal(pedido.Id)" style="cursor:pointer; color: #009bdb; font-weight: 600;">

                  Ocultar
                </h5>

            </div>

            <div class="colunas-extrato">
                <h5 (click)="payWithCreditCard(pedido.Id, pedido.CartaoCashlessId)" style="cursor:pointer; text-align: right; color: #333; font-weight: 600;">Cartão de
                  Crédito</h5>

                  <h5 (click)="payWithBalance(pedido.Id)" *ngIf="pedido.PedidoPodeSerPagoComSaldo" style="cursor:pointer; text-align: right; color: #333; font-weight: 600;">Pagar
                      com Saldo</h5>

            </div>
          </li>
          <div *ngIf="pedido.MostraDetalhes && pedido.Produtos && pedido.Produtos.length > 0" class="list-consumo">
            <ul>
              <li>
                <h1>Produto</h1>
                <h1>Preço</h1>
                <h1>Quantidade</h1>
                <h1>Total</h1>
              </li>
              <li *ngFor="let detail of pedido.Produtos">
                <p style="    padding-left: 10px; padding-right: 10px;">{{ detail.Nome }}</p>
                <p>R$ {{ detail.Valor.toFixed(2) }}</p>
                <p>{{ detail.Quantidade }}x</p>
                <p>R$ {{ detail.ValorTotal.toFixed(2) }}</p>
              </li>
            </ul>
          </div>

        </ul>

        <div *ngIf="defaulters.pedidos.length == 0">
          <h5>Não há dados para exibir</h5>
        </div>

      </div>

    </div>

  </div>
</div>




// WEBPACK FOOTER //
// /usr/src/app/src/app/components/defaulters/defaulters.component.html